export default __webpack_public_path__ + "static/media/F8.3a485541.png";